import React from "react";

import './TermsOfService.css'
import './TermsOfService-responsive.css';
import { Link } from "react-router-dom";
import { Slide } from "react-awesome-reveal";

const TermsOfService: React.FC = () => {
    return (
        <div className="pattern_bg bg-white">
            <section className="page_initial_section overflow-hidden">
                <div className="container-md">
                    <div className="section_heading_area">
                        <Slide direction="down" triggerOnce>
                            <h2 className="section_heading text-center">
                                Terms of Service
                            </h2>
                        </Slide>
                        <Slide direction="up" delay={100} triggerOnce>
                            <p className="section_desc text-center">
                                Effective date: September 18, 2024
                            </p>
                        </Slide>
                    </div>

                    <fieldset className="terms_service_container first">
                        <div className="content_number_area">1</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">Who we are</h5>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">1.1</h6>
                                <p className="terms_service_desc">
                                    We are Nuvay Private Ltd trading as “Traqdo”. Our company information is at the end of this document.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">2</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">What this is all about</h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">2.1</h6>
                                <p className="terms_service_desc">
                                    These are our terms and conditions which apply to our Service (explained below). Please read the entire document carefully and contact us if anything is unclear. We’ve tried to make it user-friendly but please note that the summaries/explanations for each section in capitals aren’t a substitute for the rest of the text. Please save a copy for future reference. These terms are only available in English and they replace any previous versions.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">2.2</h6>
                                <p className="terms_service_desc">
                                    Where you communicate with us on behalf of an organisation, you promise that you have authority to do so.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">3</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">Some definitions</h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION TELLS YOU WHAT CERTAIN WORDS MEAN WHEREVER THEY ARE USED WITH A CAPITAL LETTER IN THIS DOCUMENT
                                </p>
                            </div>

                            <div className="terms_service_list_container">
                                <ul className="terms_service_list">
                                    <li>
                                        “Consumer” - an individual acting for purposes which are wholly or mainly outside that person’s trade, business, craft or profession.
                                    </li>
                                    <li>
                                        “Content” - all information of whatever kind displayed, stored or sent on or via our Service including Input Data.
                                    </li>
                                    <li>
                                        “Input Data” – information that you input into our Service such as contact lists and documents.
                                    </li>
                                    <li>
                                        “Mobile App” – the Traqdo mobile application.
                                    </li>
                                    <li>
                                        “Service” – our Mobile App, our Web App, our website and any related services.
                                    </li>
                                    <li>
                                        “Store” – the app distributor from which you download our Mobile App (e.g., Apple App Store, Google Play App Store).
                                    </li>
                                    <li>
                                        “Store Terms” – any applicable rules, policies or terms of the relevant Store.
                                    </li>
                                    <li>
                                        “Web App” – the Traqdo web application.
                                    </li>
                                    <li className="mb-0">
                                        “User” - people or organisations using our Service (whether or not registered with us).
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">4</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                How you enter a legal contract with us
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION TELLS YOU HOW AND WHEN YOU BECOME LEGALLY BOUND BY A CONTRACT WITH US
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">4.1</h6>
                                <p className="terms_service_desc">
                                    By registering on our Web App, you enter a legal contract with us to use our Service. Alternatively, if you first download our Mobile App, you enter into a legal contract with us at that point.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">4.2</h6>
                                <p className="terms_service_desc">
                                    For Mobile App users: These terms and conditions are an “end user licence agreement” between you and us (not the Store) in relation to our Mobile App (i.e., setting out how we allow you to use our Mobile App). We, and not the Store, are solely responsible for the Mobile App and its content. You agree that the Store has no obligation to supply any maintenance or support services in relation to the Mobile App.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">4.3</h6>
                                <p className="terms_service_desc">
                                    By accessing any part of our Service that does not require registration/payment, you are also bound by these terms to the extent they are relevant.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">5</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Consumer legal right to cancel (“cooling off”)
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: CONSUMERS MAY HAVE THE RIGHT TO GET OUT OF THE CONTRACT WITHIN THE FIRST 14 DAYS
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">5.1</h6>
                                <p className="terms_service_desc">
                                    If you are a Consumer, you may have the legal right to cancel this contract within 14 days of the start of the contract if you comply with the requirements explained in the Annex at the end of this document.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">5.2</h6>
                                <p className="terms_service_desc">
                                    However, you lose the right to cancel where the supply of digital content (i.e., the Mobile App) began before the end of cancellation period with your specific agreement, and you agreed that your right to cancel would be lost in such case.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">6</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Changing these terms and conditions
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: WE CAN CHANGE THESE TERMS BUT YOU MAY HAVE CERTAIN OPTIONS IF YOU DISAGREE
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">6.1</h6>
                                <p className="terms_service_desc">
                                    We may change these terms and conditions. We will give you reasonable notice before they take effect by posting them on our website and/or communicating them to you by email or otherwise.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">6.2</h6>
                                <p className="terms_service_desc">
                                    If you don’t agree to the new terms, you should end this contract  as explained below before the new terms take effect.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">7</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Your right to use our Service
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION SETS OUT CERTAIN LIMITS ON YOUR RIGHT TO USE OUR SERVICE
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">7.1</h6>
                                <p className="terms_service_desc">
                                    We grant you a limited personal non-transferable right to use our Service on any applicable device owned or controlled by you subject to these terms and conditions.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">7.2</h6>
                                <p className="terms_service_desc">
                                    If you use our Mobile App, you agree to comply with the applicable Store Terms. If our usage rules conflict with the Store Terms, the latter take priority. If you download the Mobile App from Apple, you can only use it on Apple-branded devices that you own or control except in the case of other accounts associated with you via family sharing or volume purchasing. You can find the Apple/Google Play UK terms here:&nbsp;
                                    <Link to={'https://www.apple.com/uk/legal/internet-services/itunes/uk/terms.html'} className="terms_service_link" target="_blank">
                                        www.apple.com/uk/legal/internet-services/itunes/uk/terms.html
                                    </Link>,&nbsp;
                                    <Link to={'https://play.google.com/intl/en_uk/about/play-terms/index.html'} className="terms_service_link" target="_blank">
                                        www.play.google.com/intl/en_uk/about/play-terms/index.html
                                    </Link>
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">7.3</h6>
                                <p className="terms_service_desc">
                                    You agree to comply with any applicable third party terms when using our Service.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">8</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Standard of Service
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION SETS OUT THE LEGAL STANDARD OF SERVICE THAT WE PROMISE YOU
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">8.1</h6>
                                <p className="terms_service_desc">
                                    Subject to the rest of these terms, we agree to provide our Service with reasonable skill and care.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">9</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Behaviour when using our Service
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION SETS OUT THE BEHAVIOUR AND OTHER REQUIREMENTS TO USE OUR SERVICE
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">9.1</h6>
                                <p className="terms_service_desc">
                                    You agree not to do any of the following in connection with our Service:
                                </p>
                            </div>

                            <div className="terms_service_list_container mb-3">
                                <ul className="terms_service_list">
                                    <li>
                                        break the law or infringe anyone else’s rights;
                                    </li>
                                    <li>
                                        send, store, display or link to unlawful, infringing or otherwise inappropriate Content;
                                    </li>
                                    <li>
                                        victimise or harass other people;
                                    </li>
                                    <li>
                                        use offensive, obscene, abusive, discriminatory or other inappropriate language or images;
                                    </li>
                                    <li>
                                        deceive or mislead anyone;
                                    </li>
                                    <li>
                                        send, store, display or link to any Content that includes someone else’s personal information unless that person is 18 years or over and you have obtained their written consent or you are otherwise legally permitted to do so;
                                    </li>
                                    <li>
                                        impersonate anyone;
                                    </li>
                                    <li>
                                        use our Service to help you compete with us or to infringe our rights;
                                    </li>
                                    <li>
                                        disrupt our Service, e.g., spam, viruses or phishing;
                                    </li>
                                    <li>
                                        interfere with or damage our Service or gain unauthorised access to any part of our system, data, passwords or otherwise;
                                    </li>
                                    <li>
                                        intercept or modify communications;
                                    </li>
                                    <li>
                                        impose an unreasonable load on our Service;
                                    </li>
                                    <li>
                                        deliberately exploit any bugs found within our Service;
                                    </li>
                                    <li>
                                        get around any security features including those designed to stop copying of Content; or
                                    </li>
                                    <li className="mb-0">
                                        attempt, encourage or assist any of the above.
                                    </li>
                                </ul>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">9.2</h6>
                                <p className="terms_service_desc">
                                    You agree to:
                                </p>
                            </div>

                            <div className="terms_service_list_container mb-3">
                                <ul className="terms_service_list">
                                    <li>
                                        comply with the guidance/requirements on our Service; and
                                    </li>
                                    <li className="mb-0">
                                        cooperate reasonably with us in relation to our Service.
                                    </li>
                                </ul>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">9.3</h6>
                                <p className="terms_service_desc">
                                    You agree to ensure that any contact or other information that you supply to us is accurate and not misleading and you will tell us if there are any important changes. We are not responsible for checking or updating your contact information even if we have reason to think that it is wrong or out of date (e.g., because our email is returned). In any case, you accept the risk that for whatever reason notifications or alerts may not be correctly sent out by our Service or received by the intended recipient and you must diarise key dates and/or follow up communications as appropriate.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">10</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Your Content
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION CONTAINS CERTAIN PROMISES BY YOU REGARDING YOUR CONTENT AND GIVES US SOME RIGHTS INCLUDING TO REMOVE/DELETE/DISCLOSE THE CONTENT IN CERTAIN CIRCUMSTANCES
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">10.1</h6>
                                <p className="terms_service_desc">
                                    You are responsible for your Content.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">10.2</h6>
                                <p className="terms_service_desc">
                                    You agree that you have (and will keep) all rights needed to enable us to use your Content as contemplated by the Service and these terms and conditions.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">10.3</h6>
                                <p className="terms_service_desc">
                                    Provided we comply with data protection law, we are entitled (without telling you or giving you a refund) to reject, suspend, alter, remove or delete Content or to disclose to the police or other relevant authorities or to a complainant any Content or behaviour if it is the subject of complaint or where we have reason to believe that it breaches our terms and conditions, or that such steps are necessary to protect us or others, or that a criminal offence may have been committed, or where required by law or where requested by the police or other appropriate authorities or companies who provide relevant services to us.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">10.4</h6>
                                <p className="terms_service_desc">
                                    We are not legally responsible if your Content is misused by others. You must take reasonable care when deciding which Content to display on or send via our Service.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">10.5</h6>
                                <p className="terms_service_desc">
                                    We may place advertisements near or within your Content. If so, we retain all revenue from such advertisements.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">10.6</h6>
                                <p className="terms_service_desc">
                                    It is your responsibility to make your own frequent backups/exports of Content if you want protection if it is lost or damaged. We are not responsible for loss or damage that could have been avoided if you had made a backup (but this doesn’t affect our duties under data protection laws).
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">10.7</h6>
                                <p className="terms_service_desc">
                                    Uninstalling the Mobile App may result in deletion of all Content on your device.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">11</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Dealing with other Users
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION CONTAINS IMPORTANT WARNINGS ABOUT YOUR DEALINGS WITH OTHER USERS AND WHAT TO DO IF YOU ENCOUNTER MISBEHAVIOUR
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">11.1</h6>
                                <p className="terms_service_desc">
                                    You deal with other Users at your own risk. We are not legally responsible for any dealings between Users.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">11.2</h6>
                                <p className="terms_service_desc">
                                    If you encounter any inappropriate Content or behaviour in connection with our Service or if you have any concerns for your safety, you agree to immediately (1) stop communicating with the other person and (2) tell us. Please also use any available blocking mechanisms and seek relevant external help If appropriate (e.g., from law enforcement authorities).
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">12</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Other peoples’ services / advertising / websites
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: WE AREN’T RESPONSIBLE FOR ADVERTISING ETC BY OTHER PEOPLE ON OUR SERVICE
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">12.1</h6>
                                <p className="terms_service_desc">
                                    We may display other peoples’ services, advertising and/or links to other websites. We do not recommend or endorse, nor are we legally responsible for, any of these.  You use them at your own risk.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">13</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                If you create an account on our Service
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: YOU ARE RESPONSIBLE FOR YOUR ACCOUNT AND MUST KEEP IT CONFIDENTIAL
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">13.1</h6>
                                <p className="terms_service_desc">
                                    Unless otherwise specifically stated on our Service, your account is for your personal use only and is non-transferable. You agree not to allow anyone else to use your account except to grant access to authorised Users where our Service is designed to allow this.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">13.2</h6>
                                <p className="terms_service_desc">
                                    You agree to take reasonable care to keep your login information confidential and to tell us immediately of any apparent breach of security such as loss or misuse of a password.   You are responsible for your authorised Users and for unauthorised people who use your account or identity (unless and to the extent that we are at fault).
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">14</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Paying us (where applicable)
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION COVERS YOUR PAYMENT OBLIGATIONS
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">14.1</h6>
                                <p className="terms_service_desc">
                                    Certain features of our Service are chargeable. Payment is in advance. Prices, subscription periods and payment methods are as explained on our Service. The prices shown include any applicable VAT or other sales tax  unless we say otherwise.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">14.2</h6>
                                <p className="terms_service_desc">
                                    If we have mispriced any part of our Service, we are not obliged to supply the Service at that price provided we notify you. If we do notify you, then you can decide if you want to continue with the Service at the correct price.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">14.3</h6>
                                <p className="terms_service_desc">
                                    Your subscription will continue to be auto-renewed for the subscription period you signed up to unless you end your subscription at least 14 days before the next renewal date by following the instructions on our Service. Ending your subscription does not entitle you to a refund (unless Consumer cooling off rights apply).
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">14.4</h6>
                                <p className="terms_service_desc">
                                    You authorise us and our payment provider to place a hold on, or charge, your payment card for the relevant amounts or otherwise take payment whenever payments are due in accordance with this agreement. It is your responsibility to update your payment card details as necessary.
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">14.5</h6>
                                <p className="terms_service_desc">
                                    We may at any time change our subscription prices. We will give you notice by email at least two months before any price change takes effect. If you do not agree with the new price, you should end your subscription. Otherwise, the next renewal of your subscription after our notice will be at the new price.
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">14.6</h6>
                                <p className="terms_service_desc">
                                    You must contact us immediately with full details if you dispute any payment.
                                </p>
                            </div>
                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">14.7</h6>
                                <p className="terms_service_desc">
                                    You agree that you are legally bound by the terms and conditions of any payment providers whose services you use on our Service. We aren’t responsible for what they do or don’t do.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">15</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Paying us (where applicable)
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION COVERS YOUR PAYMENT OBLIGATIONS
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">15.1</h6>
                                <p className="terms_service_desc">
                                    Certain features of our Service are chargeable. Payment is in advance. Prices, subscription periods and payment methods are as explained on our Service. The prices shown include any applicable VAT or other sales tax  unless we say otherwise.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">15.2</h6>
                                <p className="terms_service_desc">
                                    If we have mispriced any part of our Service, we are not obliged to supply the Service at that price provided we notify you. If we do notify you, then you can decide if you want to continue with the Service at the correct price.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">15.3</h6>
                                <p className="terms_service_desc">
                                    Your subscription will continue to be auto-renewed for the subscription period you signed up to unless you end your subscription at least 14 days before the next renewal date by following the instructions on our Service. Ending your subscription does not entitle you to a refund (unless Consumer cooling off rights apply).
                                </p>
                            </div>
                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">15.4</h6>
                                <p className="terms_service_desc">
                                    You authorise us and our payment provider to place a hold on, or charge, your payment card for the relevant amounts or otherwise take payment whenever payments are due in accordance with this agreement. It is your responsibility to update your payment card details as necessary.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">16</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Support
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION SETS OUT THE AMBIT OF OUR SUPPORT SERVICE, IF APPLICABLE
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">16.1</h6>
                                <p className="terms_service_desc">
                                    The Service includes support only if we opt to provide support and, if so, by the specified contact methods. Any support service is only intended to address configuration and proper use of, or any errors or interruptions arising from, our Service.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">16.2</h6>
                                <p className="terms_service_desc">
                                    Unless we say otherwise, any support that we do opt to provide is only available by email between 9am and 5pm on business days in England and we do not guarantee any particular response times or outcomes. Any response times given are calculated in English business hours/days unless we say otherwise. We are allowed to change or withdraw our support service at any time.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">16.3</h6>
                                <p className="terms_service_desc">
                                    In any event, we aren’t obliged to supply support if you owe us any money or have otherwise broken this contract.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">17</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Ending or suspending this contract
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION TELLS YOU WHEN AND HOW YOU OR WE CAN END (OR SUSPEND) THE CONTRACT AND, IF SO, WHAT HAPPENS
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">17.1</h6>
                                <p className="terms_service_desc">
                                    You are entitled to end this contract at any time by emailing us to the email address shown below as explained on our Service and, if you are a Mobile App User, by uninstalling the Mobile App from all of your devices. If you are a subscriber (1) termination doesn’t entitle you to a refund unless you have Consumer “cooling off” rights as explained above and (2) you must also end your subscription as explained above (“Paying us…”) and termination will not take effect until your subscription ends. You will have to make another payment if you terminate less than 14 days before the next renewal date.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">17.2</h6>
                                <p className="terms_service_desc">
                                    We are entitled to end this contract at any time or suspend part or all of our Service or impose restrictions on our Service if:
                                </p>
                            </div>

                            <div className="terms_service_list_container mb-3">
                                <ul className="terms_service_list">
                                    <li>
                                        you break this contract;
                                    </li>
                                    <li>
                                        any fees payable by you are unpaid or charged back;
                                    </li>
                                    <li>
                                        acting reasonably, we think that it is necessary to protect you, us or others;
                                    </li>
                                    <li>
                                        we are required to do so by applicable law or regulation or to comply with an order, instruction or request from a competent authority; or
                                    </li>
                                    <li className="mb-0">
                                        you or anyone on your behalf acts inappropriately towards us or our staff or agents.
                                    </li>
                                </ul>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">17.3</h6>
                                <p className="terms_service_desc">
                                    If we suspend our Service, you remain responsible to pay for our Service during the period of suspension if you were at fault. We are entitled to make resumption of a suspended Service subject to reasonable conditions including payment of a reasonable reconnection fee.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">17.4</h6>
                                <p className="terms_service_desc">
                                    If you are a free User, we are entitled to end this contract at any time and for any reason.
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">17.5</h6>
                                <p className="terms_service_desc">
                                    We are entitled at any time to end this contract if we terminate our Service as a whole if in our reasonable opinion it is necessary to do so for security, technical or operational reasons.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">17.6</h6>
                                <p className="terms_service_desc">
                                    If this contract ends:
                                </p>
                            </div>

                            <div className="terms_service_list_container">
                                <ul className="terms_service_list">
                                    <li>
                                        Your right to use our Service and all licences are terminated.
                                    </li>
                                    <li>
                                        We are allowed to delete your Content without telling you. (See below about return/deletion of Content where we are a processor.)
                                    </li>
                                    <li>
                                        Existing rights and liabilities are unaffected.
                                    </li>
                                    <li>
                                        All terms in this contract which are stated or intended to continue after termination will continue to apply.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">18</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                If our Service doesn’t work properly
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: WE DON’T PROMISE THAT OUR SERVICE WILL BE ERROR-FREE
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">18.1</h6>
                                <p className="terms_service_desc">
                                    We do not guarantee that the Service will be uninterrupted or error-free or that any Content generated, stored, transmitted or used via or in connection with the Service will be complete, accurate, secure, up to date, received or delivered correctly or at all.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">18.2</h6>
                                <p className="terms_service_desc">
                                    We are entitled without liability to suspend the Service for repair, maintenance, improvement or other technical reason. For any planned maintenance we will try to provide reasonable notice.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">19</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Disclaimers
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    HERE ARE SOME IMPORTANT LIABILITY DISCLAIMERS REGARDING OUR SERVICE
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">19.1</h6>
                                <p className="terms_service_desc">
                                    We do not guarantee that the Service will be uninterrupted or error-free or that any Content generated, stored, transmitted or used via or in connection with the Service will be complete, accurate, secure, up to date, received or delivered correctly or at all.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">19.2</h6>
                                <p className="terms_service_desc">
                                    We are entitled without notice and without liability to suspend the Service for repair, maintenance, improvement or other technical reason. We will take reasonable steps to restore the Service as quickly as possible.
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">19.3</h6>
                                <p className="terms_service_desc">
                                    If we ourselves provide any general guidance or other similar information on or via our Service, we do not guarantee that such information is accurate or up to date or relevant to you and we do not accept legal responsibility for it. Before acting on such information, you must make your own appropriate and careful enquiries including as to its accuracy and suitability for your purposes. You rely on such information at your own risk.
                                </p>
                            </div>
                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">19.4</h6>
                                <p className="terms_service_desc">
                                    It is your responsibility to satisfy yourself that use of our Service enables compliance with all applicable laws and regulations relating to your industry or generally (e.g., employment, health & safety, tax). We are not responsible for such matters.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">20</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Compatibility of Mobile App
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: WE DON’T GUARANTEE OUR MOBILE APP IS OR WILL REMAIN COMPATIBLE WITH YOUR DEVICE
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">20.1</h6>
                                <p className="terms_service_desc">
                                    We do not guarantee that the Mobile App is or will be compatible with any particular mobile devices or associated operating systems (OS’s).  You must check that the Mobile App works on your applicable device before you subscribe. You acknowledge that the supplier of the device or OS may issue an update that causes our Mobile App to stop working. We may issue Mobile App updates through the Store; if so, you may not be able to use our Mobile App properly or at all until you have downloaded the update, which may be subject to agreement to new terms and conditions. It is your responsibility to frequently monitor for Mobile App updates and to install them as soon as they become available.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">21</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Restrictions on our legal responsibility – very important
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION LIMITS OUR LEGAL RESPONSIBILITY IN VARIOUS WAYS AND MAKES YOU RESPONSIBLE FOR CERTAIN LOSSES WE SUFFER, EG IF YOU BREAK THE CONTRACT
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">21.1</h6>
                                <p className="terms_service_desc">
                                    Nothing in this agreement in any way limits or excludes our liability for negligence causing death or personal injury or for fraud or fraudulent misrepresentation or for anything which may not legally be excluded or limited. In this section, any reference to us includes our employees and agents, who have the right to enforce this agreement.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">21.2</h6>
                                <p className="terms_service_desc">
                                    If you are a Consumer, subject to the above we shall not be liable for any loss or damage where:
                                </p>
                            </div>

                            <div className="terms_service_list_container mb-3">
                                <ul className="terms_service_list">
                                    <li>
                                        there is no breach of a legal duty owed to you by us;
                                    </li>
                                    <li>
                                        such loss or damage was not reasonably foreseeable (meaning it was not an obvious consequence of our breach or not contemplated by you and us at the time we entered into this contract);
                                    </li>
                                    <li>
                                        (and to the extent that) such loss or damage is your fault, for example by not complying with this agreement; or
                                    </li>
                                    <li className="mb-0">
                                        such loss or damage relates to a business of yours.
                                    </li>
                                </ul>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">21.3</h6>
                                <p className="terms_service_desc">
                                    If you are a Consumer, you will be responsible to us for any reasonably foreseeable loss or damage we suffer (including claims made by other people) resulting from your breach of this agreement or misuse of our Service.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">21.4</h6>
                                <p className="terms_service_desc">
                                    The following clauses apply only if you are not a Consumer:
                                </p>
                            </div>

                            <div className="terms_service_list_container">
                                <ul className="terms_service_list">
                                    <li>
                                        To the fullest extent allowed by law, you and we exclude all terms, conditions, warranties and representations howsoever arising, whether imposed by statute or by law or otherwise, that are not expressly stated in this agreement.
                                    </li>
                                    <li>
                                        Subject to the first paragraph in this section (“Nothing in this agreement…”), we shall under no circumstances whatever be liable under or in connection with this agreement, whether in contract, tort (including negligence), misrepresentation, breach of statutory duty, or otherwise, for any:
                                    </li>
                                    <ul className="terms_service_sub_list">
                                        <li>
                                            loss of profit; loss of data; loss of use; loss of production; loss of contract; loss of opportunity; loss of savings; or harm to reputation or loss of goodwill; or
                                        </li>
                                        <li>
                                            indirect, consequential or special losses.
                                        </li>
                                    </ul>
                                    <li>
                                        Subject to the first paragraph in this section (“Nothing in this agreement…”), if you are or were a subscriber, our total liability in respect of all other losses arising  under or in connection with this agreement whether in contract, tort (including negligence), misrepresentation, breach of statutory duty, or otherwise, for any act or omission or series of connected acts or omissions shall in no circumstances exceed the total fees paid or payable by you to us in connection with our Service in the 12 months before the first act or omission complained of.
                                    </li>
                                    <li>
                                        You agree to indemnify us against all claims and liabilities arising out of or in connection with your use of the Service and/or breach of this agreement (except insofar as we are at fault).
                                    </li>
                                    <li className="mb-0">
                                        This agreement constitutes the entire agreement between us with respect to its subject matter and supersedes any previous communications or agreements between us. We both acknowledge that there have been no misrepresentations and that neither of us has relied on any pre-contractual statements.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">22</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Intellectual property rights (IP)
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION CONFIRMS THAT YOU AND WE REMAIN OWNERS OF COPYRIGHT AND OTHER IP RIGHTS IN OUR RESPECTIVE CONTENT AND SETS OUT HOW WE ALLOW EACH OTHER TO USE THE CONTENT
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">22.1</h6>
                                <div className="w-100">
                                    <p className="terms_service_desc text_italic text_bold">
                                        IP in your Content
                                    </p>
                                    <p className="terms_service_desc">
                                        You remain the owner of the IP in any Content you provide to us. You allow us, at no cost and for so long as this contract lasts, to use such material insofar as reasonably necessary for our Service.
                                    </p>
                                </div>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">22.2</h6>
                                <div className="w-100">
                                    <p className="terms_service_desc text_italic text_bold">
                                        IP in our Content
                                    </p>
                                    <p className="terms_service_desc">
                                        We and/or our partners own the IP in all Content that we use on or in connection with our Service. Let’s call this “our Content”.
                                    </p>
                                </div>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">22.3</h6>
                                <p className="terms_service_desc">
                                    You may view our Content on your device for your private personal, non-commercial and (if you are a business) your internal business use only. Unless these terms specifically allow you to or we give you clear written permission, you must not otherwise use all or any part of our Content including by copying, publishing (on the Internet or otherwise), selling or altering it, taking extracts from it or passing it on to other people.  You must not misrepresent the ownership or source of our Content, for example by changing or removing any legal notices or author attributions.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">22.4</h6>
                                <p className="terms_service_desc">
                                    Just to be clear - you must not collect, scrape, harvest, frame or deep-link to our Content without our specific prior written consent.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">22.5</h6>
                                <p className="terms_service_desc">
                                    As regards our Mobile App, you must not reverse-engineer or decompile any of our software in any way (except to the extent allowed by applicable law). You must not alter or create or use a modified or derivative version of our software or distribute or sublicense our software to third parties.  You must take reasonable steps to ensure that our software is not disclosed to anyone else.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">22.6</h6>
                                <div className="w-100">
                                    <p className="terms_service_desc text_italic text_bold">
                                        Our design service
                                    </p>
                                    <p className="terms_service_desc">
                                        If we create any designs for you, we license our designs for your own use only in connection with our Service subject to payment of our design fee in full.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">23</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Your personal information
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: OUR PRIVACY POLICY APPLIES
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">23.1</h6>
                                <p className="terms_service_desc">
                                    You agree that we can deal with your personal information in accordance with our&nbsp;
                                    <Link to={'/privacy-policy'} className="terms_service_link" target="_blank">
                                        Privacy Policy
                                    </Link>&nbsp;
                                    which may change from time to time. However, separate requirements apply were where we act as a “processor” – see below.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">24</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Personal information that we handle as a “processor”
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    THIS SECTION SETS OUT OUR GDPR OBLIGATIONS WHERE WE ACT AS A PROCESSOR RATHER THAN A CONTROLLER OF PERSONAL INFORMATION
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">24.1</h6>
                                <p className="terms_service_desc">
                                    This clause applies to personal information we handle as a “processor”, namely any personal information within Input Data (e.g., contact lists or personal information included in documents uploaded to our Service). We process it during the contract to enable us to provide our services to you. It is your responsibility to comply with your legal duties as a controller of such data, including to obtain any necessary consents.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">24.2</h6>
                                <p className="terms_service_desc">
                                    We agree to the following in relation to such data:
                                </p>
                            </div>

                            <div className="terms_service_list_container mb-3">
                                <ul className="terms_service_list">
                                    <li>
                                        to process it in accordance with data protection law (and nothing in this agreement relieves us of our  own direct responsibilities and liabilities under such laws);
                                    </li>
                                    <li>
                                        to process it (including when making international transfers) only in accordance with your documented instructions including as set out in this agreement (unless the law requires otherwise in which case we will tell you);
                                    </li>
                                    <li>
                                        if we transfer it outside the (which you authorise us to do) to comply with any legal basis for transfer including use of any applicable “standard contractual clauses” created by the ICO;
                                    </li>
                                    <li>
                                        to ensure that anyone we allow to deal with the data is under a confidentiality obligation;
                                    </li>
                                    <li>
                                        to take, and regularly review, appropriate security measures in accordance with data protection law and get your approval before making any important changes;
                                    </li>
                                    <li>
                                        not to subcontract any processing without your authorisation and you are deemed to authorise any sub-processors listed on our Service;
                                    </li>
                                    <li>
                                        to give you at least 14 days’ notice of any new sub-processor and you will be deemed to agree if you don’t object within that time; if you do object, we can end this contract or just the part relating to use of the new sub-processor;
                                    </li>
                                    <li>
                                        to impose on the sub-processor the same obligations as those we have under this agreement but we remain fully liable to you for the sub-processor’s obligations;
                                    </li>
                                    <li>
                                        to take reasonable steps to help you comply with your own data protection obligations including regarding data subject requests, security, notifying data breaches and data protection impact assessments;
                                    </li>
                                    <li>
                                        unless we are legally required to retain the data, to delete it after 14 days following the end of the contract during which period you should export the data if wish to retain it;
                                    </li>
                                    <li>
                                        to provide you with all information necessary to show that we have complied with our data obligations and to allow and cooperate with audits and inspections by you and your auditor; and
                                    </li>
                                    <li className="mb-0">
                                        to tell you immediately if we think that an instruction you give us doesn’t comply with data protection laws.
                                    </li>
                                </ul>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">24.3</h6>
                                <p className="terms_service_desc">
                                    We are entitled at any time by giving you 30 days’ notice in writing to replace this clause with any applicable controller to processor standard clauses or similar terms adopted by the Information Commissioner.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">25</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Things we can’t control
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: WE AREN’T RESPONSIBLE FOR “ACTS OF GOD”
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">25.1</h6>
                                <p className="terms_service_desc">
                                    We are not liable for failure to perform or delay in performing any obligation under this agreement if the failure or delay is caused by any circumstances beyond our reasonable control including third party telecommunication failures and epidemics/pandemics.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">26</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Transferring this contract to someone else
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: WE CAN PASS THIS CONTRACT TO SOMEONE ELSE BUT YOU NEED OUR PERMISSION TO DO LIKEWISE
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">26.1</h6>
                                <p className="terms_service_desc">
                                    We may transfer all or part of our rights or duties under this agreement provided we take reasonable steps to ensure that your rights under this agreement are not prejudiced. As this agreement is personal to you, you may not transfer any of your rights or duties under it without our prior written consent.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">27</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                English law and courts
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    IN SHORT: ENGLISH LAW APPLIES AND ONLY UK COURTS CAN ADJUDICATE ON DISPUTES
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">27.1</h6>
                                <p className="terms_service_desc">
                                    This contract is under English law and any disputes will be decided only by the courts of the United Kingdom.  If you are a Consumer, you will benefit from any mandatory provisions of the law of the country in which you are resident. Nothing in these terms and conditions affects your rights as a Consumer to rely on such mandatory provisions of local law.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">28</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                General
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    HERE ARE SOME FINAL BUT IMPORTANT POINTS THAT APPLY
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">28.1</h6>
                                <p className="terms_service_desc">
                                    We may send all notices under this agreement by email to the most recent email address you have given us. You can send notices to our email address shown below. Headings used in this agreement are for information and not binding. If any part of this agreement is ineffective or unenforceable for any reason, the rest of the agreement will still apply. If either of us overlooks any breach of this agreement by the other, it can still be actioned later. A person who is not a party to this agreement can’t enforce it unless the agreement says otherwise. The parties are independent contractors and, except as otherwise specifically stated above, nothing in this agreement makes any party an agent, employee or representative of the other.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">29</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Extra legal terms
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <p className="terms_service_desc">
                                    HERE ARE SOME ADDITIONAL LEGAL TERMS REQUIRED BY APPLE REGARDING OUR MOBILE APP
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">29.1</h6>
                                <p className="terms_service_desc">
                                    We, not Apple, are responsible for addressing your claims or the claims of any third party relating to the Mobile App or the end-user’s possession and/or use of that Mobile App, including, but not limited to: (i) product liability claims; (ii) any claim that the Mobile App fails to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection, privacy or similar legislation including use of HealthKit and HomeKit frameworks.
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">29.2</h6>
                                <p className="terms_service_desc">
                                    If any third party claim that the Mobile App or your possession and use of the Mobile App infringes their intellectual property rights, we, not Apple, will be solely responsible for the investigation, defence, settlement and discharge of any such intellectual property infringement claim.
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">29.3</h6>
                                <p className="terms_service_desc">
                                    You represent and warrant that (i) you are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a “terrorist supporting” country; and (ii) you are not listed on any U.S. Government list of prohibited or restricted parties.
                                </p>
                            </div>
                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">29.4</h6>
                                <p className="terms_service_desc">
                                    You acknowledge and agree that Apple and its subsidiaries are third party beneficiaries of this agreement, and that the Apple will have the right (and will be deemed to have accepted the right) to enforce this agreement against you as a third party beneficiary thereof.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">30</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Complaints
                            </h5>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">30.1</h6>
                                <p className="terms_service_desc">
                                    If you have any complaints, please contact us via the contact details shown below.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">31</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Information about us
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">31.1</h6>
                                <p className="terms_service_desc">
                                    <span className="text_bold">Company name: </span>
                                    Nuvay Private Ltd
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">31.2</h6>
                                <p className="terms_service_desc">
                                    <span className="text_bold">Trading name: </span>
                                    “Traqdo”
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">31.3</h6>
                                <p className="terms_service_desc">
                                    <span className="text_bold">Country of incorporation: </span>
                                    England and Wales
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">31.4</h6>
                                <p className="terms_service_desc">
                                    <span className="text_bold">Registered number: </span>
                                    13309098
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">31.5</h6>
                                <p className="terms_service_desc">
                                    <span className="text_bold">Registered office and contact address: </span>
                                    6 Diamond Road, Ruislip, England, HA4 0PG
                                </p>
                            </div>
                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">31.6</h6>
                                <p className="terms_service_desc">
                                    <span className="text_bold">Contact email address: </span>
                                    <Link to={'mailto:info@nuvay.digital'} className="terms_service_link">
                                        info@nuvay.digital
                                    </Link>
                                </p>
                            </div>
                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">31.7</h6>
                                <p className="terms_service_desc">
                                    <span className="text_bold">Other contact information: </span>
                                    See our website/contact page,&nbsp;
                                    <Link to={'/contact-us'} className="terms_service_link" target="_blank">
                                        contact
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </section>
        </div>
    )
}

export default TermsOfService;